import { render, staticRenderFns } from "./location-delivery-payment-configurator.vue?vue&type=template&id=51577391&scoped=true"
import script from "./location-delivery-payment-configurator.vue?vue&type=script&lang=js"
export * from "./location-delivery-payment-configurator.vue?vue&type=script&lang=js"
import style0 from "./location-delivery-payment-configurator.vue?vue&type=style&index=0&id=51577391&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51577391",
  null
  
)

export default component.exports